/* ============================================================
   custom.header-desktop.js -- injects the desktop "full mockup" hero and
   ribbons into the existing red masthead, and keeps the cart ribbon count
   in step. Loaded by sections/custom-catbar.liquid.

   WHY JS: the hero and ribbons must sit INSIDE .ffg-masthead__block /
   .ffg-masthead__outer (positioned + clipped by the red field). Those live
   in sections/custom-header.liquid, which is left untouched; this appends
   the decorative nodes at runtime. They are aria-hidden / presentational,
   so nothing meaningful is withheld from initial HTML. The green category
   bar and its search field are real server-rendered Liquid (custom-catbar),
   not injected here. Styles: assets/custom.header-desktop.css.
   ============================================================ */
(function () {
  'use strict';

  function data() {
    var el = document.getElementById('ffg-header-desktop-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }

  function injectDecor(cfg) {
    var block = document.querySelector('.ffg-masthead__block');
    var outer = document.querySelector('.ffg-masthead__outer');
    if (!block || !outer) return;

    if (cfg.showHero && cfg.heroUrl && !block.querySelector('.ffg-masthead__hero')) {
      var img = el('img', 'ffg-masthead__hero');
      img.src = cfg.heroUrl;
      /* 2x for retina — same treatment the Hawaii ribbon gets. Guarded because
         file_img_url returns nothing if the file is ever renamed, and an empty
         srcset would override a perfectly good src. */
      if (cfg.heroUrl2x) {
        img.srcset = cfg.heroUrl + ' 1x, ' + cfg.heroUrl2x + ' 2x';
      }
      img.alt = '';
      img.setAttribute('role', 'presentation');
      img.setAttribute('aria-hidden', 'true');
      img.width = 360;
      img.height = 330;
      img.loading = 'eager';
      img.decoding = 'async';
      var stage = block.querySelector('.ffg-masthead__stage');
      block.insertBefore(img, stage || null);
    }

    /* HANDMADE IN HAWAII — real artwork when there is any, the CSS ribbon
       otherwise (Devin, 31 Jul). The drawn ribbon was always a stand-in: it is
       a cream box with a swallowtail clip-path and two folded tails, and the
       supplied PNG is a proper illustrated banner with its own curl, its own
       tilt and its own shading. So the image is NOT dropped into that shape —
       .ffg-ribbon--art turns all of it off (see custom.header-desktop.css).

       The fallback stays because the image comes from content/files, which is
       a different lifecycle to the theme: if that file is ever renamed or
       removed, file_img_url returns nothing, hawaiiImage lands empty and the
       banner goes back to being drawn rather than disappearing. */
    if (cfg.showHawaii && !block.querySelector('.ffg-ribbon--hawaii')) {
      if (cfg.hawaiiImage) {
        var art = el('img', 'ffg-ribbon--hawaii ffg-ribbon--art');
        art.src = cfg.hawaiiImage;
        if (cfg.hawaiiImage2x) {
          art.srcset = cfg.hawaiiImage + ' 1x, ' + cfg.hawaiiImage2x + ' 2x';
        }
        art.alt = cfg.hawaiiText || 'Handmade in Hawaii';
        /* Intrinsic ratio of the upload (685x451), so the row above it cannot
           jump while the file loads. The rendered size comes from CSS. */
        art.width = 685;
        art.height = 451;
        art.loading = 'eager';
        art.decoding = 'async';
        block.appendChild(art);
      } else if (cfg.hawaiiText) {
        var rib = el('div', 'ffg-ribbon ffg-ribbon--hawaii');
        rib.setAttribute('aria-hidden', 'true');
        var span = el('span', 'ffg-ribbon__text');
        span.textContent = cfg.hawaiiText;
        rib.appendChild(span);
        block.appendChild(rib);
      }
    }

    if (cfg.showCart && !outer.querySelector('.ffg-cartribbon')) {
      /* ART VERSION — same trade as the Hawaii banner above: when a real
         illustration exists it REPLACES the drawn shape rather than being
         poured into it, and the drawn one stays as the fallback for when the
         file is renamed or removed. The data attributes are identical in both,
         so paint() keeps updating the count either way. */
      if (cfg.cartArt) {
        var flag = el('a', 'ffg-cartribbon ffg-cartribbon--art');
        flag.href = cfg.cartUrl || '/cart';
        var fn = parseInt(cfg.cartCount, 10);
        if (isNaN(fn)) fn = 0;
        flag.setAttribute('aria-label', 'View cart, ' + fn + (fn === 1 ? ' item' : ' items'));

        /* OPENS THE DRAWER, FALLS BACK TO THE PAGE. `on:click` with a
           `#id/method` value is Horizon's own declarative binding, dispatched
           from a DOCUMENT-level listener in assets/component.js — the same one
           the header's cart button and the PDP's CHECKOUT button use.

           THE href STAYS. It is what makes this work without JavaScript, and
           what a middle-click or "open in new tab" still does. The listener
           below suppresses the navigation ONLY when there is a drawer to open,
           so if the drawer is ever removed the flag quietly goes back to being
           a link to /cart rather than a dead control.

           preventDefault does not stop propagation, so Horizon's document-level
           handler still receives the click and does the toggling. */
        flag.setAttribute('on:click', '#cart-drawer/toggle');
        flag.setAttribute('aria-haspopup', 'dialog');
        flag.setAttribute('aria-controls', 'cart-drawer');
        flag.addEventListener('click', function (e) {
          if (document.getElementById('cart-drawer')) e.preventDefault();
        });

        var img = el('img', 'ffg-cartribbon__art');
        img.src = cfg.cartArt;
        if (cfg.cartArt2x) img.srcset = cfg.cartArt + ' 1x, ' + cfg.cartArt2x + ' 2x';
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        /* The upload's intrinsic ratio, so the flag cannot resize as it loads. */
        img.width = 378;
        img.height = 194;
        img.loading = 'eager';
        img.decoding = 'async';
        flag.appendChild(img);

        var fcount = el('span', 'ffg-cartribbon__count');
        fcount.setAttribute('data-ffg-cart-count', '');
        fcount.textContent = fn;
        var flabel = el('span', 'ffg-cartribbon__label');
        var fword = el('span');
        fword.setAttribute('data-ffg-cart-word', '');
        fword.textContent = fn === 1 ? 'Item' : 'Items';
        flabel.appendChild(fword);
        flabel.appendChild(document.createTextNode(' in'));
        var fcta = el('span', 'ffg-cartribbon__cta');
        fcta.textContent = 'Cart';

        flag.appendChild(fcount);
        flag.appendChild(flabel);
        flag.appendChild(fcta);
        outer.appendChild(flag);
      } else {
        var a = el('a', 'ffg-cartribbon');
      a.href = cfg.cartUrl || '/cart';
      var n = parseInt(cfg.cartCount, 10);
      if (isNaN(n)) n = 0;
      a.setAttribute('aria-label', 'View cart, ' + n + (n === 1 ? ' item' : ' items'));
      var top = el('span', 'ffg-cartribbon__top');
      var count = el('span', 'ffg-cartribbon__count');
      count.setAttribute('data-ffg-cart-count', '');
      count.textContent = n;
      var label = el('span', 'ffg-cartribbon__label');
      var word = el('span');
      word.setAttribute('data-ffg-cart-word', '');
      word.textContent = n === 1 ? 'Item' : 'Items';
      label.appendChild(word);
      label.appendChild(document.createTextNode(' in Cart'));
      top.appendChild(count);
      top.appendChild(label);
      var cta = el('span', 'ffg-cartribbon__cta');
        cta.textContent = 'Checkout';
        a.appendChild(top);
        a.appendChild(cta);
        outer.appendChild(a);
      }
    }
  }

  /* ---- cart count live sync (best-effort, never throws) ---- */
  function paint(n) {
    n = parseInt(n, 10);
    if (isNaN(n)) return;
    document.querySelectorAll('[data-ffg-cart-count]').forEach(function (e) { e.textContent = n; });
    document.querySelectorAll('[data-ffg-cart-word]').forEach(function (e) { e.textContent = n === 1 ? 'Item' : 'Items'; });
    document.querySelectorAll('.ffg-cartribbon').forEach(function (e) {
      e.setAttribute('aria-label', 'View cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }
  /* ---- SHARED CART READ -------------------------------------------------
     Two scripts watch the cart and both want the same answer: custom.header-
     desktop.js for the header count, ffg-freeship.js for the shipping badge.
     Each used to fetch /cart.js on its own, so every add, delete or quantity
     change cost two identical round trips.

     DEFINED DEFENSIVELY IN BOTH FILES, IDENTICALLY, GUARDED ON window. That is
     deliberate and it is what avoids the obvious drawback of sharing: neither
     script may depend on the other having loaded. This one runs on every page
     with a masthead; the badge only exists on product pages. Whichever arrives
     first defines the reader, the second sees it and reuses it, and either can
     be removed tomorrow without breaking the other.

     TWO LAYERS OF DEDUPE, because they solve different problems:
       - inflight: concurrent callers share one request. This is the common
         case — one cart change fires several events at once.
       - a 300ms cache: callers that arrive just AFTER a request settles reuse
         the answer instead of asking again. Short on purpose; the cart is
         authoritative elsewhere and a stale count is worse than a fetch.

     It never throws. A failed read resolves null and each caller leaves its own
     display alone, which is the same behaviour they had independently. */
  window.__ffgCartRead = window.__ffgCartRead || (function () {
    var inflight = null;
    var last = null;
    var lastAt = 0;
    return function (maxAgeMs) {
      var age = typeof maxAgeMs === 'number' ? maxAgeMs : 300;
      if (last && Date.now() - lastAt < age) return Promise.resolve(last);
      if (inflight) return inflight;
      if (!window.fetch) return Promise.resolve(null);
      inflight = fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          inflight = null;
          if (c) { last = c; lastAt = Date.now(); }
          return c;
        })
        .catch(function () { inflight = null; return null; });
      return inflight;
    };
  })();

  function refresh() {
    window.__ffgCartRead().then(function (c) { if (c) paint(c.item_count); });
  }

  function init() {
    var cfg = data();
    if (cfg) injectDecor(cfg);
    var bubble = document.querySelector('cart-icon [data-cart-count], .cart-count, .cart-bubble__count, [ref=cartBubbleCount]');
    if (bubble && window.MutationObserver && !bubble.dataset.ffgCartObserved) {
      bubble.dataset.ffgCartObserved = '1';
      new MutationObserver(function () {
        var t = (bubble.textContent || '').replace(/[^0-9]/g, '');
        if (t !== '') paint(t);
      }).observe(bubble, { childList: true, characterData: true, subtree: true });
    }
  }

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'cart:add',
   'on:cart:add', 'variant:add', 'ajaxProduct:added', 'product:added']
    .forEach(function (ev) { document.addEventListener(ev, refresh); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
